// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"434":"e770f93a","892":"c05d0bcb"}[chunkId] + ".chunk.css";
};